"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingOverlay = LoadingOverlay;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("../lib/cn");
const icon_1 = require("./icon");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 30 Oct 2026 · A SURFACE WHOSE FIGURES ARE FOR SOMETHING ELSE THAN ASKED.   │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The product owner, on the project time machine: a past day can take seconds to rebuild, and
 * the dashboard sat showing the previous day's figures with nothing to say they were about to
 * change. This lays a scrim over the surface and says what is being read.
 *
 * ⚠️ **For a changed QUESTION only — a picked date, not a refresh.** `state-rules.md` §1 keeps a
 * live refresh behind the figures already shown; this is for the case where the figures shown
 * answer a question the reader no longer asked. The caller decides which it is.
 *
 * ⚠️ The parent is `relative`; the card is `sticky`, so it stays in view on a tall dashboard.
 * One `role="status"`, which is the surface's one announcer while it shows.
 */
function LoadingOverlay({ show, label, className, }) {
    if (!show)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, cn_1.cn)('bg-background/60 absolute inset-0 z-20', className), children: (0, jsx_runtime_1.jsx)("div", { className: "sticky top-24 flex justify-center pt-16", children: (0, jsx_runtime_1.jsxs)("div", { role: "status", "aria-live": "polite", className: "bg-card text-muted-foreground flex items-center gap-2 rounded-lg border px-4 py-2.5 text-[12.5px] shadow-sm", children: [(0, jsx_runtime_1.jsx)(icon_1.Icon, { name: "refresh-cw", size: 14, className: "animate-spin" }), label] }) }) }));
}
//# sourceMappingURL=loading-overlay.js.map